export const APP_BAR_HEIGHT = 64;
export const VERSION_APP_HEIGHT = 32;

export const DRAWER_WIDTH = 264;
export const SHRUNK_DRAWER_WIDTH = 80;
